import { render } from "./CardCoupons.vue?vue&type=template&id=0b46028a&scoped=true"
import script from "./CardCoupons.vue?vue&type=script&lang=js"
export * from "./CardCoupons.vue?vue&type=script&lang=js"

import "./CardCoupons.vue?vue&type=style&index=0&id=0b46028a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kamon\\Documents\\Workspace\\ECOUPONS\\coupons-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46028a"]])

export default __exports__